import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const formContactInit = () => {
  const mainPattern = document.querySelectorAll('.gg-form-event');
  mainPattern.forEach((module) => {
    const eventCity = module.querySelector('.gg-form-event__city');
    let dateCity = module.querySelector('.gg-form-event__date-city');
    if (eventCity && eventCity.textContent.trim() === '') {
      dateCity.classList.add('no-city');
    }

    const date = module.querySelector('.gg-form-event__date');
    const dateLocation = module.querySelector('.gg-form-event__date-location');
    if(dateLocation && dateLocation.textContent.trim() === '') {
      dateLocation.style.display = 'none';
    }
    else {
      if (dateLocation) {
        date.style.display = 'none';
        eventCity.style.display = 'none';
        dateCity.classList.add('no-city');
      }
    }
  });

  document.addEventListener('click', function (event) {
    const forms = document.querySelectorAll('.gg-contact-us-form__box form');
    let flag = true;
    forms.forEach((form) => {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
  
        let requiredInputs = form.querySelectorAll('input[required]');
        let firstEmptyInput = null;
  
        requiredInputs.forEach((input) => {
          if (input.value.trim() === '' && flag) {
            firstEmptyInput = input;
            flag = false;
          }
        });
  
        if (firstEmptyInput) {
          firstEmptyInput.focus();
        } else {
          console.log('Form submitted');
        }
      });
    });
  }, false);
};

Gravity.ready(() => {
  formContactInit();
});
